import Icons, {IconType} from '../ui/IconButton/Icons';

export type DialogPage = {
    label: string;
    icon: IconType;
    iconColor?: string;
};

export const PROFILE_PAGES: DialogPage[] = [
    {label: 'My Profile',      icon: Icons.USER,  iconColor: 'blue'},
    {label: 'Profile Picture', icon: Icons.USER,  iconColor: 'blue'},
    {label: 'Change Email',    icon: Icons.EMAIL, iconColor: 'blue'},
    {label: 'Change Password', icon: Icons.LOCK,  iconColor: 'blue'},
];

export const BILLING_PAGES: DialogPage[] = [
    {label: 'Billing',              icon: Icons.INVOICE},
    {label: 'Subscription',         icon: Icons.INVOICE},
    {label: 'Invoices',             icon: Icons.INVOICE},
    {label: 'Payment Methods',      icon: Icons.CREDIT_CARD_PLAIN},
    {label: 'Cancel Subscription',  icon: Icons.INVOICE},
];
